import React from 'react';
import CreatableSelect from "react-select/creatable";
import {Theme, GroupBase} from "react-select";
import {CreatableProps} from "react-select/creatable";
import NoOptionsMessage from "../SelectWrapper/components/NoOptionsMessage";

/**
 * Обертка CreatableSelect с темой приложения
 * Позволяет выбирать из списка или вводить произвольное значение
 */
function CreatableSelectWrapper<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  components,
  ...props
}: CreatableProps<Option, IsMulti, Group>) {
  return <CreatableSelect<Option, IsMulti, Group>
    components={{
      NoOptionsMessage,
      ...components,
    }}
    styles={{
      valueContainer: (provided) => ({
        ...provided,
        paddingLeft: 12,
        paddingRight: 12,
      }),
      singleValue: (provided) => ({
        ...provided,
        margin: 0,
      }),
      input: (provided) => ({
        ...provided,
        margin: 0,
      })
    }}
    theme={getSelectTheme}
    {...props}
  />;
}

const getSelectTheme = (theme: Theme): Theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#f9612b',
    primary25: '#fba080',
    primary50: '#fba080',
    neutral20: '#dddddd',
    neutral30: '#ced4da',
  },
})

export default CreatableSelectWrapper;
